import React, { useEffect, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { useLocation, Link } from "react-router-dom";
import TranscreatePages from "./TranscreatePages";
import { Spinner } from "flowbite-react";

// interface Book {
//   book: Record<string, any>;
//   src_lang: string;
//   target_lang: string;
//   target_culture: string;
// }

interface BookReq {
  id: string;
}

interface TranslatedResponse {
  id: string;
  translated_book: Record<string, string>; // page number -> base64 string
}

const TranslatePage: React.FC = () => {
  const location = useLocation();
  const state = location.state as string;
  const [loading, setLoading] = useState(true);
  const [translatedId, setTranslatedId] = useState(String);

  const body: BookReq = { id: state };

  const downloadPDF = async (docId: string) => {
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }/download-pdf/${docId}?transcreated=${false}`
      );
      if (!response.ok) {
        throw new Error("Failed to download PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "assembled.pdf"; //reminder to store book name later
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const handleClick = () => {
    const docId = translatedId;
    downloadPDF(docId);
  };

  useEffect(() => {
    const translate = async () => {
      setLoading(true);
      try {
        const bookData: AxiosResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/book/${state}`
        );
        console.log(bookData);
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/translate-book/`,
          bookData
        );
        setTranslatedId(response.data.id);
      } catch (error) {
        console.error("Translation failed", error);
      } finally {
        setLoading(false);
      }
    };

    translate();
  }, []);

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f0f4f8",
          fontFamily: "'Arial', sans-serif",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "6px solid #ccc",
            borderTop: "6px solid #3182ce",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <p style={{ marginTop: "1rem", fontSize: "1.2rem", color: "#555" }}>
          Translating...
        </p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #81E6D9, #3182CE)",
        color: "#fff",
        fontFamily: "'Arial', sans-serif",
      }}
    >
      <h2 style={{ fontSize: "2.5rem", marginBottom: "2rem" }}>
        Translation complete!
      </h2>
      {/* <button onClick={handleClick} style={{ marginLeft: "1rem" }}>
        Download Translated PDF!
      </button> */}
      <Link to="/transcreate" state={translatedId}>
        <button
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: "0.8rem 1.5rem",
            fontSize: "1.2rem",
            fontWeight: "bold",
            color: "#fff",
            background:
              "linear-gradient(135deg,rgb(10, 114, 52),rgb(17, 140, 23))",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            //boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(135deg, #3182ce, #2b6cb0)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(135deg,rgb(10, 114, 52),rgb(17, 140, 23))")
          }
        >
          Start Transcreation
        </button>
      </Link>

      <button
        onClick={handleClick}
        style={{
          marginTop: "10px",
          padding: "0.8rem 1.5rem",
          fontSize: "1.2rem",
          fontWeight: "bold",
          color: "#fff",
          background:
            "linear-gradient(135deg,rgb(234, 82, 82),rgb(229, 48, 48))",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          //boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.background =
            "linear-gradient(135deg, #ed8936, #dd6b20)")
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.background =
            "linear-gradient(135deg,rgb(234, 82, 82),rgb(229, 48, 48))")
        }
      >
        Download Translated PDF
      </button>
    </div>
  );
};

export default TranslatePage;
